import React from 'react';
import cn from 'classnames';
import { Info } from 'react-feather';
import LESSON_STATES from 'constants/lesson_states';
import Tooltip from 'components/shared/Tooltip';

const STATE_LABELS = {
  [LESSON_STATES.CLASSIC]: t('lesson_overview.published'),
  [LESSON_STATES.NEW_VERSION_PENDING]: t(
    'lesson_overview.published_unpublished_draft',
  ),
  [LESSON_STATES.DRAFT]: t('lesson_overview.draft'),
  [LESSON_STATES.PUBLISHED]: t('lesson_overview.published'),
};

const Pill = ({ state }) => {
  const classes = cn('Pill lh-22 fz-18 px-32 py-2 d-ib', {
    'Pill--tealLighter': state === LESSON_STATES.DRAFT,
    'Pill--outline': state !== LESSON_STATES.DRAFT,
    'Pill--navyDark':
      state === LESSON_STATES.PUBLISHED || state === LESSON_STATES.CLASSIC,
    'Pill--dark': state === LESSON_STATES.NEW_VERSION_PENDING,
  });

  return (
    <p
      className={classes}
      dangerouslySetInnerHTML={{
        __html: STATE_LABELS[state] || t('lesson_overview.published'),
      }}
    />
  );
};

const TooltipText = () => (
  <span className="w-260 p-8 d-f fd-c ws-pr fz-14 lh-16 text-wrap">
    {t('contents.index.scorm.overview_tooltip')}
  </span>
);

const StatusPill = ({ lesson }) => {
  const isScorm = lesson.scorm;
  return (
    <span className="d-f mb-40">
      <Pill state={lesson.state} />
      {isScorm && (
        <>
          <span className="lh-24 fz-16 ml-20 mt-4">
            {t('lesson_overview.scorm_upcase')}
          </span>
          <Tooltip text={<TooltipText />}>
            <Info data-toggle="tooltip" className="ml-4 pt-6 c-midnight-50" />
          </Tooltip>
        </>
      )}
    </span>
  );
};

export default props => <StatusPill {...props} />;
